export default __webpack_public_path__ + "static/media/netoToMyob2Way.e8966f8c.png";